import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material';
import { ApiService } from '../../../core/services/api.service';
import { MessageService } from '../../../core/services/message.service';
import { DataTableComponent } from '../../../shared/data-table/data-table.component';
import { UserListDto } from '../../../dtos/user-list-dto';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})

export class UsersComponent {
  
  @ViewChild("tableChild") tableChild: DataTableComponent<UserListDto>;
  pagePath: string = "api/user/page";
  search: any;
  searchText: string = '';
  options = {
    columnTitles: ["USERS.TABLE.ID", "USERS.TABLE.USERNAME", "USERS.TABLE.FULL_NAME", "USERS.TABLE.AUTH", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'username', "fullName", "authorization_AuthorizationEnum", "actions"],
    actionButtons: { edit: true, delete: true }
  };

  constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

  }

  goToEdit(e: any) {
    this.router.navigate(["users/edit", e.id]);
  }

  openDeleteDialog(e: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '680px',
      data: {
        title: 'DIALOGS.DELETE_USER.TITLE',
        body: 'DIALOGS.DELETE_USER.BODY',
        cancelButtonText: "GENERAL.LABELS.CANCEL",
        confirmButtonText: "GENERAL.LABELS.DELETE",
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.delete('api/user/' + e.id).subscribe((data: any) => {
          if(data.data == 1){
            this.messageService.success("USERS.MESSAGES.SUCCESS", "USERS.MESSAGES.REMOVED");
            this.tableChild.loadPage();
          }
          if(data.data == 0){
            this.messageService.error("USERS.MESSAGES.ERROR", "USERS.MESSAGES.LOGUED");
          }
        }, error => {
          this.messageService.error("USERS.MESSAGES.ERROR", error.message);
        })
      }
    });
  }

  searchUser(){
    this.search = {
      searchText: this.searchText
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
  }
}
